import React from 'react';
import { useNavigate } from 'react-router-dom';

import { BubbleStepTrackerWrapper, Container, Content } from './StepTrackerLayout.styled';
import BubbleStepTracker from 'components/v2/BubbleStepTracker/BubbleStepTracker';

import { Props } from './StepTrackerLayout.types';
import { AuthFlowLayout } from '../AuthFlowLayout/AuthFlowLayout';

export const StepTrackerLayout = (props: Props) => {
  const {
    title,
    stepNames,
    selectedStep,
    renderMainContent,
    hideBackButton,
    renderAboveTitleContent,
    renderDesktopRightSidebar
  } = props;
  const navigate = useNavigate();

  return (
    <AuthFlowLayout
      title={title}
      onBack={!hideBackButton ? () => navigate(-1) : undefined}
      renderAboveTitleContent={() => {
        return (
          <div>
            <>{renderAboveTitleContent?.()}</>
            <BubbleStepTrackerWrapper>
              <BubbleStepTracker
                steps={stepNames}
                selectedStep={selectedStep}
                onSelectStep={() => {}}
              />
            </BubbleStepTrackerWrapper>
          </div>
        );
      }}
      renderMainContent={(mobile: boolean) => {
        return (
          <Container>
            <Content>{renderMainContent(mobile)}</Content>
          </Container>
        );
      }}
      renderDesktopRightSidebar={renderDesktopRightSidebar}
    />
  );
};
